import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid maincontent g-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationVerticalNav = _resolveComponent("NotificationVerticalNav")!
  const _component_ChatVerticalNav = _resolveComponent("ChatVerticalNav")!
  const _component_ToastDisplay = _resolveComponent("ToastDisplay")!
  const _component_HorizontalNav = _resolveComponent("HorizontalNav")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_AccessibilityModal = _resolveComponent("AccessibilityModal")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass(["container-fluid", {'side-nav-closed': _ctx.store.state.sidenav === '', 'side-nav-opened': _ctx.store.state.sidenav !== ''}])
  }, [
    (_ctx.store.state.sidenav === 'notifications')
      ? (_openBlock(), _createBlock(_component_NotificationVerticalNav, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.store.state.sidenav === 'chat')
      ? (_openBlock(), _createBlock(_component_ChatVerticalNav, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ToastDisplay),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_HorizontalNav),
      _createVNode(_component_router_view),
      _createVNode(_component_Footer)
    ]),
    _createVNode(_component_AccessibilityModal)
  ], 2))
}